import { render, staticRenderFns } from "./FormTaxpayerType.vue?vue&type=template&id=25419e0a&scoped=true&"
import script from "./FormTaxpayerType.vue?vue&type=script&lang=js&"
export * from "./FormTaxpayerType.vue?vue&type=script&lang=js&"
import style0 from "./FormTaxpayerType.vue?vue&type=style&index=0&id=25419e0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25419e0a",
  null
  
)

export default component.exports